<script setup>
import FileApi from '@api/file.api'
import { reactive, onMounted } from 'vue';
import { useToast } from "vue-toastification"

defineOptions({
    inheritAttrs: false,
})

let filesData = reactive({})

const props = defineProps({
    files: {
        type: [Array, Object],
        required: true,
    },
    type: {
        type: String,
        default: 'image',
        validator: function (value) {
            // The value must match one of these strings
            return ['image', 'video', 'none'].indexOf(value) !== -1;
        },
    },
    editable: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["update:files", 'deleted'])

onMounted(() => {
    filesData = props.files
})

const deleteFile = (file) => {
    FileApi.delete(file)
        .then(resp => {
            if (Array.isArray(filesData)) {
                let index = filesData.findIndex(
                    p => p.id === file.id
                );
                filesData.splice(index, 1);
            } else {
                filesData = {};
            }

            emit('update:files', filesData)
            emit('deleted')
            useToast().success(resp.data.message);
        }).catch((thrown) => {
            console.log(thrown);
        });
}

const openFile = (url) => window.open(url, "_blank");
</script>

<template>
    <div class="input-group">
        <label class="form-label position-relative mb-3" v-if="$attrs.label">{{ $attrs.label }}</label>

        <ul class="list-group">
            <template v-if="Array.isArray(files)">
                <template v-for="file in files" :key="file.id">

                    <li v-if="file && file.id" class="list-group-item position-relative">
                        <file :type="type" :file="file" />

                        <div class="ml-auto position-absolute top-5 start-7">
                            <button type="button" class="btn btn-dark btn-sm mx-1" @click="openFile(file.url)">
                                <!-- {{ $t('messages.open') }} -->
                                <i class="material-icons text-lg">visibility</i>
                            </button>
                            <button v-if="editable" type="button" class="btn btn-danger btn-sm" @click="deleteFile(file)">
                                <!-- {{ $t('messages.delete') }} -->
                                <i class="material-icons text-lg">delete</i>
                            </button>
                        </div>
                    </li>

                </template>
            </template>

            <template v-else>
                <li v-if="files && files.id" class="list-group-item position-relative">
                    <file :type="type" :file="files" />

                    <div class="ml-auto position-absolute top-5 start-7">
                        <button type="button" class="btn btn-dark btn-sm mx-1" @click="openFile(files.url)">
                            <!-- {{ $t('messages.open') }} -->
                            <i class="material-icons text-lg">visibility</i>
                        </button>
                        <button v-if="editable" type="button" class="btn btn-danger btn-sm" @click="deleteFile(files)">
                            <!-- {{ $t('messages.delete') }} -->
                            <i class="material-icons text-lg">delete</i>
                        </button>
                    </div>
                </li>
            </template>

        </ul>
    </div>
</template>
